import SystemNotifications from "./SystemNotifications";

export default SystemNotifications;
